import { theme } from './theme-preval';
export default theme;